import React, { useEffect, useState } from 'react';

import { Button, Col, Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { useAppSelector } from 'hooks';
import { SectionTitle } from 'components/UI';
import { isPatientArchived } from 'store/patient/reducer';

import AddSmartEventsModal from './AddSmartEventsModal';
import SmartEvent from './SmartEvent';

interface ISmartEventsProps {
  smartAlerts: ICarePlanSmartAlert[] | undefined;
  getCarePlan: () => any;
  carePlanTemplate?: ICarePlanTemplate;
}

const SmartEvents = ({ smartAlerts, getCarePlan, carePlanTemplate }: ISmartEventsProps) => {
  const intl = useIntl();
  const [smartEvents, setSmartEvents] = useState(smartAlerts || []);
  const [showAddModal, setShowAddModal] = useState(false);
  const isTemplateGlobal = carePlanTemplate?.template_type === 'GLOBAL';
  const _isPatientArchived = useAppSelector(isPatientArchived);
  const onDeleteSmartEvent = (attribute: string) => {
    setSmartEvents(smartEvents.filter((event) => event.attribute !== attribute));
  };

  const currentSmartEvents = smartEvents.map((x) => x.attribute);

  useEffect(() => {
    setSmartEvents(smartAlerts || []);
  }, [smartAlerts]);

  return (
    <div className="mb-5" data-test="careplan-smart-events-section">
      <div className="d-flex justify-content-between align-items-center">
        <SectionTitle
          dataTestId="careplan-smart-events-title"
          label={intl.formatMessage({ id: 'smartEventsKey' })}
        />
        {!isTemplateGlobal && (
          <Button
            size="sm"
            variant="link mb-1"
            onClick={() => setShowAddModal(true)}
            data-test="careplan-smart-events-btn"
            disabled={_isPatientArchived}
          >
            + {intl.formatMessage({ id: 'smartEventsKey' })}
          </Button>
        )}
      </div>
      <Row>
        {smartEvents.length > 0 ? (
          smartEvents.map((smartEvent) => (
            <SmartEvent
              key={smartEvent.attribute_id}
              smartEvent={smartEvent}
              onDeleteSmartEvent={onDeleteSmartEvent}
              carePlanTemplate={carePlanTemplate}
              disabled={_isPatientArchived}
            />
          ))
        ) : (
          <Col>
            <div
              className="bg-light text-center p-3 font-weight-bolder"
              data-test="careplan-smart-events-empty"
            >
              {intl.formatMessage({ id: 'noAlertsSet' })}
            </div>
          </Col>
        )}
      </Row>

      <AddSmartEventsModal
        show={showAddModal}
        setShow={setShowAddModal}
        getCarePlan={getCarePlan}
        currentSmartEvents={currentSmartEvents}
        carePlanTemplate={carePlanTemplate}
      />
    </div>
  );
};

export default SmartEvents;
